import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=3502b6a0"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_a684d0c3315dfbe7fcb599809449fa35/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports